import React from "react";

import Workspace from "../../components/Workspace";

class WorkspaceScreen extends React.Component {
  render() {
    return (
      <>
        <Workspace {...this.props} />
      </>
    );
  }
}

export default WorkspaceScreen;
